import React from "react";
import { Bar } from "react-chartjs-2";

const WithdrawalStrategyChart = ({ projectionTable }) => {
  // Extract data from your projectionTable
  const labels = projectionTable && projectionTable.map((row) => row.year);

  const taxableWithdrawals =
    projectionTable &&
    projectionTable.map((row) => row.taxableWithdrawals || 0);
  const taxDeferredWithdrawals =
    projectionTable &&
    projectionTable.map((row) => row.taxDeferredWithdrawals || 0);
  const rothWithdrawals =
    projectionTable && projectionTable.map((row) => row.rothWithdrawals || 0);
  const data = {
    labels,
    datasets: [
      {
        label: "Taxable Acct: Withdrawals",
        data: taxableWithdrawals,
        backgroundColor: "#09A84D", // Deep blue
        borderColor: "#09A84D",
        borderWidth: 1,
      },
      {
        label: "Tax-Deferred Acct: Withdrawals",
        data: taxDeferredWithdrawals,
        backgroundColor: "#E53E3E", // Burnt orange
        borderColor: "#E53E3E",
        borderWidth: 1,
      },
      {
        label: "Roth Acct: Withdrawals",
        data: rothWithdrawals,
        backgroundColor: "#2A3DA3", // Deep green
        borderColor: "#2A3DA3",
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    tooltips: {
      callbacks: {
        label: function (tooltipItem, chartData) {
          const datasetLabel =
            chartData.datasets[tooltipItem.datasetIndex].label || "";
          const value = tooltipItem.yLabel;
          const formattedValue = new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }).format(value);
          return `${datasetLabel}: ${formattedValue}`;
        },
      },
    },
    scales: {
      xAxes: [
        {
          gridLines: {
            color: "rgba(0, 0, 0, 0)",
          },
        },
      ],
      yAxes: [
        {
          ticks: {
            callback: function (value) {
              return new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }).format(value);
            },
          },
        },
      ],
    },
  };

  return (
    <div
      className="chart-container"
      style={{ background: "white", borderRadius: "8px", padding:"8px", marginTop: "1rem", padding: "20px" }}
    >
      <Bar data={data} options={options} height={380} />
    </div>
  );
};

export default WithdrawalStrategyChart;
